<div class="header" *ngIf="!isLoadingDownload">
    <div class="top">
        <h2>{{ 'admin.request-history.return-history-table.title' | translate }}</h2>
        <app-report-download-form [tableConfig]="tableConfig"
                                  [isLoading]="isLoadingDownload"
                                  (filterChange)="onFilterChange(tableFilters, $event)"
                                  (reportDownload)="onReturnsHistoryDownload($event)">
        </app-report-download-form>
    </div>
    <div class="bottom">
        <app-input placeholder="{{'admin.tools.table.columns.toolName' | translate}}"
                   [(ngModel)]="toolName" (ngModelChange)="onNameChanged()">
        </app-input>
        <app-input [placeholder]="'admin.tools.table.columns.toolUid' | translate"
                   [(ngModel)]="toolUid" (ngModelChange)="onUidChanged()">
        </app-input>
    </div>
</div>
<div class="body">
    <app-tool-return-history-table [toolReturnHistory]="toolReturnHistory"
                                   [isLoading]="isLoadingReturnsHistory"
                                   [tableConfig]="tableConfig"
                                   [hasTitle]="false"
                                   [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                   (sortChange)="onSortChange($event)"
                                   (pageChange)="onPageChange($event)"
                                   (rowClick)="onTableRowClick($event)"
                                   (filterChange)="onFilterChange($event.filters, reportFilters)">
    </app-tool-return-history-table>
</div>
<app-pending-tool-returns-modal label='lineSetter.tool-returns.pages.toolReturn'></app-pending-tool-returns-modal>
